import * as React from 'react';
import { DemoSection, DemoSectionProps } from '../components/DemoSection';
import { MoreOptionsMessage } from '../../MoreOptionsMessage';

interface Props extends DemoSectionProps {}
const MESSAGE = `Upload your own photos, see more layout options, add custom CSS and more from your editor after getting started with this design. `;
export const Advanced: React.SFC<Props> = ({ open, onSectionToggle }) => {
  return (
    <DemoSection open={open} onSectionToggle={onSectionToggle} section="advanced" name="Advanced" subtitle={null}>
      <MoreOptionsMessage message={MESSAGE} />
    </DemoSection>
  );
};
